/**
 * welcome 音不発の可能性ログ送信
 * - キャスト側 chat 画面で「ユーザー入室の welcome 音が鳴らなかった可能性がある」と検出したら
 *   /api/v1/welcome-miss-log に POST して Slack 通知する
 * - 認証は session cookie / actor_id はサーバー側で確定するため payload に含めない
 * - 同一 (kind, room_id) は 5分1回に絞る（sessionStorage）
 */
(function () {
    var API_URL = '/api/v1/welcome-miss-log';
    var DEDUP_INTERVAL = 5 * 60 * 1000;
    var STORAGE_KEY = 'vl_welcome_miss_last_sent';

    function _dedupKey(kind, roomId) {
        return (kind || '') + ':' + (roomId || 0);
    }

    function _isDuplicate(kind, roomId) {
        try {
            var raw = sessionStorage.getItem(STORAGE_KEY);
            if (!raw) return false;
            var data = JSON.parse(raw);
            var last = data[_dedupKey(kind, roomId)];
            if (!last) return false;
            return (Date.now() - last) < DEDUP_INTERVAL;
        } catch (e) {
            return false;
        }
    }

    function _recordSent(kind, roomId) {
        try {
            var raw = sessionStorage.getItem(STORAGE_KEY);
            var data = raw ? JSON.parse(raw) : {};
            data[_dedupKey(kind, roomId)] = Date.now();
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (e) {
            // noop
        }
    }

    function _send(payload) {
        var body = JSON.stringify(payload);

        try {
            if (navigator.sendBeacon) {
                var blob = new Blob([body], { type: 'application/json' });
                if (navigator.sendBeacon(API_URL, blob)) return;
            }
        } catch (e) {
            // フォールバック
        }

        try {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', API_URL, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            var token = document.querySelector('meta[name="csrf-token"]');
            if (token && token.content) {
                xhr.setRequestHeader('X-CSRF-TOKEN', token.content);
            }
            xhr.send(body);
        } catch (e) {
            // 送信失敗は無視
        }
    }

    window.VLReportWelcomeMiss = function (info) {
        try {
            info = info || {};
            var kind = info.kind || 'unknown';
            var roomId = info.room_id || 0;

            if (_isDuplicate(kind, roomId)) return;
            _recordSent(kind, roomId);

            _send({
                kind:       kind,
                room_id:    roomId,
                user_id:    info.user_id || 0,
                context:    info.context || {},
                page_url:   location.href,
                user_agent: navigator.userAgent,
                is_mobile:  !!info.is_mobile,
            });
        } catch (e) {
            // 送信失敗は無視
        }
    };
})();
